
import {
	Component,
	Vue
} from "vue-property-decorator";
import {
	handleClipboard
} from '@/utils/clipboard'
import Step from '@/components/step.vue'
import {
	orderSupportdetail,
	orderSupportcheckPass,
	orderSupportcheckReject,
	confirmReceiveGoods,
	orderSupportmodifyRealRefundMoney,
	orderSupportmodifyAlipayAccount,
	orderSupportrefund,
	orderSupporterrorReturnExpressNoAlert,
	orderSupportmodifyReturnFreightInsuranceMoney,
	orderSupportreturnExpressedit,
	orderSupportmodifyProductState,
	orderSupportsendGoodsedit,
	orderSupportinsteadCustomerConfirmReceiveGoods,
	orderSupportreturnAddressedit
} from '@/api/after_sales'
import {
	lookExpress
} from '@/api/order'
import collapseItem from '@/components/collapse.vue';
import PageFooter from '@/components/page-footer.vue';
import Message from '@/components/message.vue';
import RefundChangeSku from '../order/components/refund-change-sku.vue';
import previewImg from "@/components/previewImg.vue"
import dialog from "@/components/dialog.vue"
import fillinlogistics from './components/fillinlogistics.vue';
import {
	afterStatus,
	afterSalesResults,
	afterSalesTypes,
} from '@/utils/config'
import {
	getExpressList,
	providerReturnAddressSelectItem
} from '@/api/logistics';
import changeRemark from "@/views/aftersales/components/changeRemark.vue"
import DetailDialog from "../member/customer-statistic/components/detail-dialog.vue";
@Component({
	name: 'after-sales-detail',
	components: {
		Step,
		collapseItem,
		PageFooter,
		RefundChangeSku,
		'slz-message': Message,
		'slz-dialog': dialog,
		previewImg,
		fillinlogistics,
		changeRemark
	}
})
export default class AfterSalesDetail extends Vue {
	private pageloading = false
	private detailmsg: any = {}
	//待审核 = 0,已驳回 = 10,待买家退回 = 20,买家已寄回 = 30,待商家寄出 = 40,待买家确认收货 = 50,已完结 = 60,已关闭 = 70,
	private stepList: any = []
	private showMessage = false
	private msgrul = ''
	private urlshow = false
	private fileType = 'image'

	private passshow = false
	private ejectedshow = false
	private ejectedmsg: any = {
		SupportNo: '',
		RejectReason: '',
		SystemRemark: '',
	}
	private logisticsshow = false
	private logisticsmsg: any = []
	private logisticsdata: any = {}

	private takeGoodsShow = false
	private fillinShow = false
	private lookloading = false

	private changerefundShow = false
	private refundnum = ''

	private changeaccountShow = false
	private changeaccountmsg: any = {}

	private refundagainShow = false
	private refundagainloading = false
	private refundmsg: any = {
		title: '',
		content: '',
		Show: false,
		type: 'warn',
		showicon: true
	}
	private smsShow = false
	private refundreasonlist = [{
		value: '拾物Zone原因-补贴'
	},
	{
		value: '供应商原因-补贴'
	},
	]
	private RefundReasonForCustomerService = ''
	private FinanceOrderSettleReduceProviderSettleMoney = ''
	private changefreight = false
	private freightnum = ''

	private itemlist: any = []
	private detailloading = false
	private logisticsitem: any = {}

	private expressList: any = []
	private KDForm: any = {}
	private KDshow = false
	private ProductState = 0
	private ProductStateList = [
		{ value: 0, label: '已收到货' },
		{ value: 1, label: '未收到货' },
	]
	private amendShow = false
	private ReturnFreightInsuranceResponsibleParty = null
	private assemblyRefundShow = false
	private ProductMixRefundRate = 100
	private CheckRemark = ''
	private merchantKDshow = false
	private merchantKDForm: any = {}
	private receiveShow = false
	private receivemsg: any = {
		show: false,
		message: '',
		content: '',
	}
	private remarkShow = false
	private bannerColor = {
		0: '#f92519',
		1: '#ef8733',
		2: '#2e63f6',
		3: '#1cac34',
		4: '#873df1',
	}
	private addressVisible: boolean = false;
	private addressList: any = [];


	private mounted() {
		this.getdetail();
	}

	private checkChange(e, record){
		this.addressList.map(item=>{
			item.checked = record.Id === item.Id;
			return item;
		})
		console.log(e)
	}

	private handleShowAddressPop(){
		this.addressList.map(item=>{
			item.checked = false;
			return item;
		})
		this.addressVisible = true;
	}
	private async handleSureSelectAddress(){
		let list = this.addressList.filter(item=>{return item.checked});
		if (!list.length){
			this.$message.error('请选择退货地址');
			return;
		}

		try {
			let res = await orderSupportreturnAddressedit({
				SupportNo: this.detailmsg.SupportNo,
				ProviderReturnAddressId: list[0].Id
			})
			if (res.IsSuccess) {
				this.$message.success('修改成功');
				this.addressVisible = false;
				this.getdetail();
			}
		} finally {
			//
		}
	}


	private async toeeceive() {
		try {
			let res = await orderSupportinsteadCustomerConfirmReceiveGoods({
				SupportNo: this.detailmsg.SupportNo,
			})
			if (res.IsSuccess) {
				this.receiveShow = false
				this.receivemsg = {
					show: true,
					message: res.Message,
					content: res.Result.MessageContent || '',
				}
				this.getdetail()
			}
		} finally {
			//
		}
	}
	private confirmassemblyRefund() {
		let two = /^\d+(\.\d{1,2})?$/
		if (!this.ProductMixRefundRate) {
			this.$message.error('请输入退款比例')
			return
		}
		if (this.ProductMixRefundRate < 0.01 || this.ProductMixRefundRate > 100 || !two.test(String(this.ProductMixRefundRate))) {
			this.$message.error('请输入0.01~100以内的退款比例')
			return
		}
		this.realTake()
	}
	private signfor() {
		// console.log(this.detailmsg.SupportType==2&&this.detailmsg.ProductType==1)
		if ((this.detailmsg.SupportType == 1 || this.detailmsg.SupportType == 2)
			&& this.detailmsg.SupportState == 30 && this.detailmsg.ReturnFreightInsuranceMoney > 0) {
			this.takeGoodsShow = true
			this.ReturnFreightInsuranceResponsibleParty = null
		} else if (this.detailmsg.SupportType == 2 && this.detailmsg.ProductType == 1) {
			this.assemblyRefundShow = true
			this.ProductMixRefundRate = 100
		} else {
			this.takeGoodsShow = true
		}
	}
	private async confirmamend() {
		try {
			this.pageloading = true
			let res = await orderSupportmodifyProductState({
				SupportNo: this.detailmsg.SupportNo,
				ProductState: this.ProductState
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.getdetail()
			}
		} finally {
			this.pageloading = false
		}
	}
	private changeState() {
		this.ProductState = JSON.parse(JSON.stringify(this.detailmsg.ProductState))
		this.amendShow = true
	}
	private async savemerchantKD() {
		if (!this.merchantKDForm.ExpressId) {
			this.$message.error('请选择物流公司')
			return
		}
		if (!this.merchantKDForm.ExpressNo) {
			this.$message.error('请输入物流单号')
			return
		}
		try {
			this.pageloading = true
			let res: any = await orderSupportsendGoodsedit(this.merchantKDForm)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.merchantKDshow = false
				this.getdetail()
			}
		} finally {
			this.pageloading = false
		}
	}
	private async saveKD() {
		if (!this.KDForm.ExpressId) {
			this.$message.error('请选择物流公司')
			return
		}
		if (!this.KDForm.ExpressNo) {
			this.$message.error('请输入物流单号')
			return
		}
		try {
			this.pageloading = true
			let res: any = await orderSupportreturnExpressedit(this.KDForm)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.KDshow = false
				this.getdetail()
			}
		} finally {
			this.pageloading = false
		}
	}
	private changeKD(type) {
		this.togetExpressList()
		if (type == 1) {
			this.KDForm = {
				SupportNo: this.detailmsg.SupportNo,
				ExpressId: this.detailmsg.ReturnExpressId,
				ExpressNo: this.detailmsg.ReturnExpressNo,
			}
		} else {
			this.merchantKDForm = {
				SupportNo: this.detailmsg.SupportNo,
				ExpressId: this.detailmsg.NewExpressId,
				ExpressNo: this.detailmsg.NewExpressNo,
			}
		}
	}
	private async togetExpressList() {
		try {
			const res: any = await getExpressList({});
			if (res.IsSuccess) {
				this.expressList = res.Result;
				// console.log(this.expressList)
			}
		} catch (e) {
			//
		}
	}
	private chooseNo(e) {
		// console.log(e)
		this.logisticsitem = e
		this.getlogistics(this.logisticsitem)
	}
	private async savefreight(type) {
		if (type) {
			let freightnum = Number(this.freightnum)
			let two = /^\d+(\.\d{1,2})?$/
			// if (isNaN(freightnum)|| freightnum < 0 || !two.test(this.freightnum)) {
			if (freightnum < 0 || !two.test(this.freightnum)) {
				this.$message.error('请输入运费金额')
				return
			} else if (freightnum > 200 || !two.test(this.freightnum)) {
				this.$message.error('运费金额不能超过200元')
				return
			}
			let res = await orderSupportmodifyReturnFreightInsuranceMoney({
				SupportNo: this.detailmsg.SupportNo,
				ReturnFreightInsuranceMoney: freightnum
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.changefreight = false
				this.freightnum = ''
				this.getdetail()
			}
		} else {
			this.changefreight = false
			this.freightnum = ''
		}
	}

	private wantchangefreight() {
		this.changefreight = true
		this.freightnum = this.detailmsg.ReturnFreightInsuranceMoney
	}

	private returntypefont() {
		let val = ''
		if (this.detailmsg.SupportType == 1) {
			val = '换货'
		} else if (this.detailmsg.SupportType == 2) {
			val = '退货'
		} else if (this.detailmsg.SupportType == 3 || this.detailmsg.SupportType == 4) {
			val = '退款'
		} else if (this.detailmsg.SupportType == 5) {
			val = '售后'
		}
		return val
	}
	private clickpass() {
		this.passshow = true
	}
	private async smsremind() {
		try {
			let res = await orderSupporterrorReturnExpressNoAlert({
				SupportNo: this.$route.query.SupportNo
			})
			if (res.IsSuccess) {
				this.$message.success('已发送短信通知用户')
			}
		} finally {
			//
		}
	}
	private copyAddress(event) {
		let text = ''
		text += this.detailmsg.ReceiveName + '  ' + this.detailmsg.ReceivePhone + '\n'
		text += this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress
		handleClipboard(text, event)
	}
	private copyaftersales(event) {
		let text = ''
		text += '★订单编号：' + this.detailmsg.OrderNoDisplay + '\n'
		text += '★售后编号：' + this.detailmsg.SupportNo + ';' + this.detailmsg.SupportTypeValue + '\n'
		text += '★申请人：' + this.detailmsg.CustomerName + '  ' + this.detailmsg.CustomerPhone + '\n'
		text += '★订单审核序列：' + this.detailmsg.CheckSequence + '\n'
		text += '★商品名称：' + this.detailmsg.ProductName + '\n'
		if (this.detailmsg.SupportType == 5) {
			text += '★商家寄出单号：' + this.detailmsg.NewExpressValue + '  ' + this.detailmsg.NewExpressNo + '\n'
		}
		text += '★发货单号：' + this.detailmsg.OrderDetailExpressInfo
		// text += this.detailmsg.OriginaldetailmsgInfoList.map(v=>{
		//   v.ChildOrdermsg = v.ChildOrderEx + ' ' + v.ChildOrderNo
		//   return v
		// }).map(v=>v.ChildOrdermsg).join(',')
		text += '\n'
		// text += '★发货单号：' + this.detailmsg.ProductName + '\n'

		text += '★寄回单号：' + this.detailmsg.ReturnExpressValue + '' + this.detailmsg.ReturnExpressNo + '\n'
		text += '★下单时间：' + this.detailmsg.OrderAddTime + '\n'
		text += '★订单信息：' + this.detailmsg.ReceiveName + '。' + this.detailmsg.ReceivePhone + '。' + this.detailmsg
			.ReceiveProvince +
			this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg.ReceiveAddress + '。' + '\n' +
			this.detailmsg.ProductName + '。' + this.detailmsg.OriginalSpecValueDisplay + 'x' + this.detailmsg
				.ProductCount + '\n'
		text += '★售后原因：' + this.detailmsg.SupportReason + '\n'
		text += '★补充描述：' + this.detailmsg.CustomerRemark + '\n'
		if (this.detailmsg.SupportType == 1) {
			text += '★换后规格：' + this.detailmsg.ProductName + '。' + this.detailmsg.NewSpecValueDisplay + 'x' + this.detailmsg
				.ProductCount + '\n'
		}
		text += '★解决方案：'
		// console.log(text,event)      
		handleClipboard(text, event)
	}
	private async confirmrefundagain() {
		try {
			this.refundagainloading = true
			let data: any = {
				SupportNo: this.detailmsg.SupportNo,
				IsModifyRemark: true,
				noError: true
			}
			let res = await orderSupportrefund(data)
			if (res.IsSuccess) {
				this.refundagainShow = false
				this.refundmsg = {
					title: '退款成功',
					content: res.Message,
					Show: true,
					type: 'success',
					showicon: true
				}
				this.getdetail()
			} else {
				await this.getdetail()
				this.refundmsg = {
					title: '退款失败',
					content: res.Message,
					Show: true,
					type: 'warn',
					showicon: true,
					RefundState: this.detailmsg.RefundState,
					ReturnFreightInsuranceState: this.detailmsg.ReturnFreightInsuranceState,
				}
			}
		} catch (err) {
			this.refundagainShow = false
		} finally {
			this.refundagainShow = false
			this.refundagainloading = false
		}
	}
	private jumpdetail() {
		this.$router.push({
			name: 'Order_Detail',
			query: {
				id: this.detailmsg.OrderNo + ''
			}
		})
	}
	private async tochangeaccount() {
		try {
			let data = {
				SupportNo: this.detailmsg.SupportNo,
				...this.changeaccountmsg
			}
			let res = await orderSupportmodifyAlipayAccount(data)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.changeaccountShow = false
				this.getdetail()
			}
		} finally {
			//
		}
	}
	private accountoperation(type: boolean) {
		if (type) {
			if (!this.changeaccountmsg.AlipayAccount) {
				this.$message.error('请输入退款收款账户')
				return
			} else if (!this.changeaccountmsg.AlipayName) {
				this.$message.error('请输入收款姓名')
				return
			}
			this.tochangeaccount()
		} else {
			this.changeaccountShow = false
		}
	}
	private clickchangeaccount() {
		this.changeaccountShow = true
		this.changeaccountmsg = {
			AlipayAccount: this.detailmsg.AlipayAccount,
			AlipayName: this.detailmsg.AlipayName,
		}
	}
	private async appendChild(type: number) {
		try {
			if (type == 1) {
				let two = /^\d+(\.\d{1,2})?$/
				if (!this.refundnum || !two.test(this.refundnum)) {
					this.$message.error('请填写正确的退款金额')
					return
				} else if (Number(this.refundnum) > 9999.99) {
					this.$message.error('退款金额超限，请勿超过1万')
					return
				}
			}
			let data = {
				SupportNo: this.detailmsg.SupportNo,
				RealRefundMoney: this.refundnum,
			}
			let res = await orderSupportmodifyRealRefundMoney(data)
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.changerefundShow = false
				this.getdetail()
			}
		} finally {
			//
		}
	}
	private clickeditrefund() {
		this.refundnum = JSON.parse(JSON.stringify(this.detailmsg.RealRefundMoney))
	}


	private async realTake() {
		try {
			let res = await confirmReceiveGoods({
				SupportNo: this.detailmsg.SupportNo,
				ReturnFreightInsuranceResponsibleParty: this.ReturnFreightInsuranceResponsibleParty,
				ProductMixRefundRate: this.ProductMixRefundRate / 100
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.takeGoodsShow = false
			}
		} finally {
			this.takeGoodsShow = false
			this.assemblyRefundShow = false
			this.$router.go(-1)
		}
	}
	private async confirmtakeGoods() {
		if ((this.detailmsg.SupportType == 1 || this.detailmsg.SupportType == 2)
			&& this.detailmsg.SupportState == 30 && this.ReturnFreightInsuranceResponsibleParty == null
			&& this.detailmsg.ReturnFreightInsuranceMoney > 0) {
			this.$message.error('请选择本次售后的运费承担方！')
			return
		}
		if (this.detailmsg.SupportType == 2 && this.detailmsg.ProductType == 1) {
			this.takeGoodsShow = false
			this.assemblyRefundShow = true
			this.ProductMixRefundRate = 100
		} else {
			this.realTake()
		}
	}

	private async getlogistics(data) {
		try {
			this.lookloading = true
			this.detailloading = true
			this.logisticsmsg = []
			let res = await lookExpress(await data)
			if (res.IsSuccess) {
				this.logisticsmsg = res.Result.sort((a, b) => {
					return -1
				}).map((item, index) => {
					item.color = index === 0 ? '#0067cc' : '#999';
					return item;
				})
				// console.log(this.logisticsmsg)
			}
		} finally {
			this.lookloading = false
			this.detailloading = false
			//
		}
	}
	private looklogistics2(item, row) {
		this.logisticsshow = true
		let data = {
			...item,
			ReceivePhone: row.ReceivePhone
		}
		this.logisticsdata = {
			ExpressValue: this.detailmsg.ReturnExpressValue,
			ExpressNo: this.detailmsg.ReturnExpressNo,
			address: this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg
				.ReceiveArea + this.detailmsg.ReceiveAddress
		}

		this.logisticsitem = data
		this.itemlist = row.OrderDetailExpressList.map(v => {
			return {
				ExpressValue: v.ExpressValue,
				ExpressId: v.ExpressId,
				ExpressNo: v.ExpressNo,
				ReceivePhone: row.ReceivePhone
			}
		})
		this.getlogistics(data)
	}
	private looklogistics(e, type?: boolean) {

		this.logisticsshow = type
		this.logisticsdata = {
			ExpressValue: e == 1 ? this.detailmsg.ReturnExpressValue : this.detailmsg.NewExpressValue,
			ExpressNo: e == 1 ? this.detailmsg.ReturnExpressNo : this.detailmsg.NewExpressNo,
			address: e == 1 ? (this.detailmsg.ReturnReceiveProvince + this.detailmsg.ReturnReceiveCity + this
				.detailmsg.ReturnReceiveArea + this.detailmsg.ReturnReceiveAddress) : (this.detailmsg
					.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this.detailmsg
						.ReceiveAddress)
		}
		let data = {
			ExpressId: e == 1 ? this.detailmsg.ReturnExpressId : this.detailmsg.NewExpressId,
			ExpressNo: e == 1 ? this.detailmsg.ReturnExpressNo : this.detailmsg.NewExpressNo,
			ReceivePhone: e == 1 ? this.detailmsg.ReturnReceivePhone : this.detailmsg.ReceivePhone,
			ExpressValue: e == 1 ? this.detailmsg.ReturnExpressValue : this.detailmsg.ExpressValue,
		}
		this.logisticsitem = data
		this.itemlist = [data]
		this.getlogistics(data)
	}

	private async confirmrejected() {
		if (!this.ejectedmsg.RejectReason) {
			this.$message.error('请填写拒绝理由')
			return
		}
		try {
			let res = await orderSupportcheckReject({
				...this.ejectedmsg,
				RefundReasonForCustomerService: this.RefundReasonForCustomerService,
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.$router.go(-1)
			}
		} finally {
			//
		}
	}

	private closerejected() {
		this.ejectedmsg = {
			SupportNo: '',
			RejectReason: '',
			SystemRemark: '',
		}
		this.ejectedshow = false
	}

	private async handlepass() {
		let two = /^\d+(\.\d{1,2})?$/
		if (this.detailmsg.SupportType == 3 && this.detailmsg.SendState == 1 && this.detailmsg.ProductState == 0) {
			if (!this.RefundReasonForCustomerService) {
				this.$message.error('请选择退款原因')
				return
			}
			if (this.RefundReasonForCustomerService == '供应商原因-补贴') {
				if (String(this.FinanceOrderSettleReduceProviderSettleMoney) == '') {
					this.$message.error('请输入需扣减供应商的结算金额')
					return
				}
				if (Number(this.FinanceOrderSettleReduceProviderSettleMoney) < 0 || Number(this.FinanceOrderSettleReduceProviderSettleMoney) > 99999.99 || !two.test(this.FinanceOrderSettleReduceProviderSettleMoney)) {
					this.$message.error('请输入正确的需扣减供应商的结算金额')
					return
				}
			}
		}
		try {
			let res = await orderSupportcheckPass({
				SupportNo: this.$route.query.SupportNo,
				IsSystem: false,
				RefundReasonForCustomerService: this.RefundReasonForCustomerService,
				FinanceOrderSettleReduceProviderSettleMoney: this.RefundReasonForCustomerService == '供应商原因-补贴' ? this.FinanceOrderSettleReduceProviderSettleMoney : '',
				CheckRemark: this.CheckRemark
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.$router.go(-1)
			}
		} finally {
			//  
		}
	}

	private ejected() {
		this.ejectedmsg = {
			SupportNo: this.$route.query.SupportNo,
			RejectReason: '',
		}
		this.ejectedshow = true
	}


	private lookmsg(e, type) {
		// console.log(1)
		this.msgrul = e
		this.fileType = type
		this.urlshow = true
	}

	private handleConfirm() {
		//
	}

	private async getdetail() {
		try {
			this.pageloading = true
			let res = await orderSupportdetail({
				SupportNo: this.$route.query.SupportNo
			})
			if (res.IsSuccess) {
				let detailmsg = res.Result
				detailmsg.SupportNo = this.$route.query.SupportNo
				detailmsg.usermsg = detailmsg.OrderCustomerName + (detailmsg.OrderCustomerRoleGrade ? '-' +
					detailmsg.OrderCustomerRoleName : '') + ' ' + detailmsg.OrderCustomerPhone
				detailmsg.proposer = detailmsg.CustomerName + (detailmsg.CustomerRoleGrade ? '-' + detailmsg
					.CustomerRoleName : '') + ' ' + detailmsg.CustomerPhone
				detailmsg.ProductMoneyMsg = '购物金：' + detailmsg.UseWaitDrawBalance + '  +  在线支付：' + detailmsg.PayMoney + '    (含运费：' + detailmsg.FreightMoney + ')'

				if (detailmsg.SupportType == 3 && detailmsg.SupportState == 0) {
					detailmsg.SupportTypeValue = detailmsg.SupportTypeValue + '-' + detailmsg.ProductStateValue
				}

				let activityMoney = [];
				if (detailmsg.RefundActivityCouponMoney){
					activityMoney.push(`优惠券减${detailmsg.RefundActivityCouponMoney}`);
				}
				if (detailmsg.RefundRedPacketMoney){
					activityMoney.push(`红包减${detailmsg.RefundRedPacketMoney}`);
				}
				if (detailmsg.RefundActivityMarkdownMoney){
					activityMoney.push(`满减活动减${detailmsg.RefundActivityMarkdownMoney}`);
				}
				if (detailmsg.RefundCrossPayRandomPromotionMoney){
					activityMoney.push(`跨境支付随机优惠减${detailmsg.RefundCrossPayRandomPromotionMoney}`);
				}
				if (detailmsg.RefundActivityOnePriceDiscountMoney){
					activityMoney.push(`随心选减${detailmsg.RefundActivityOnePriceDiscountMoney}`);
				}
				detailmsg.activityMoneyTips = activityMoney.join(',');

				this.detailmsg = detailmsg
				this.RefundReasonForCustomerService = detailmsg.RefundReasonForCustomerService
				if ([35, 36, 60].includes(detailmsg.SupportState)) {
					this.FinanceOrderSettleReduceProviderSettleMoney = detailmsg.FinanceOrderSettleReduceProviderSettleMoney
				} else {
					this.FinanceOrderSettleReduceProviderSettleMoney = detailmsg.FinanceOrderSettleReduceProviderSettleMoney || ''
				}
				// this.detailmsg.CustomerVideoUrlComplete = 'https://cdn.dkycn.cn/melyshop/video/20221021-5eca7063-124d-42a1-a6e0-0667142be21b.mp4'
				this.clickeditrefund()
				this.stepList = this.detailmsg.OrderSupportScheduleList.map(v => v.TitleDisplay)
				// console.log(this.detailmsg.OrderSupportScheduleList)
				// this.$forceUpdate()

				if([1,2].includes(detailmsg.SupportType)){
					this.getAddressList();
				}
			}
		} finally {
			this.pageloading = false
		}
	}

	private async getAddressList(){
		try {
			let res = await providerReturnAddressSelectItem({
				ProviderId: this.detailmsg.ProviderId
			})
			if (res.IsSuccess) {
				this.addressList = res.Result.map(item=>{
					item.checked =  false;
					return item;
				});
			}
		} finally {
		}
	}

	private copy(event) {
		let text = this.detailmsg.ReceiveName + ' ' + this.detailmsg.ReceivePhone + '\n' +
			this.detailmsg.ReceiveProvince + this.detailmsg.ReceiveCity + this.detailmsg.ReceiveArea + this
				.detailmsg.ReceiveAddress
		handleClipboard(text, event)
	}

	private copyNo(event, val) {
		let text = val
		handleClipboard(text, event)
	}

}
